import Icon from "@ant-design/icons";
import React from "react";

export default function SupportIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 12C5.5 10.4753 6.02496 9.07323 6.90399 7.96465L8.69112 9.75178C8.25495 10.3925 8 11.1665 8 12C8 12.8335 8.25495 13.6075 8.69112 14.2482L6.90399 16.0353C6.02496 14.9268 5.5 13.5247 5.5 12ZM9.75178 8.69112L7.96465 6.90399C9.07323 6.02496 10.4753 5.5 12 5.5C13.5247 5.5 14.9268 6.02496 16.0353 6.90399L14.2482 8.69112C13.6075 8.25495 12.8335 8 12 8C11.1665 8 10.3925 8.25495 9.75178 8.69112ZM15.3089 9.75178C15.745 10.3925 16 11.1665 16 12C16 12.8335 15.745 13.6075 15.3089 14.2482L17.096 16.0353C17.975 14.9268 18.5 13.5247 18.5 12C18.5 10.4753 17.975 9.07323 17.096 7.96465L15.3089 9.75178ZM14.2482 15.3089C13.6075 15.745 12.8335 16 12 16C11.1665 16 10.3925 15.745 9.75178 15.3089L7.96465 17.096C9.07323 17.975 10.4753 18.5 12 18.5C13.5247 18.5 14.9268 17.975 16.0353 17.096L14.2482 15.3089ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12Z"
        fill="currentColor"
      />
    </svg>
  );
};
